import {
  MenuItem,
  Select,
  Theme,
  Typography,
  withStyles
} from '@material-ui/core';
import { createStyles, WithStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import axios from '../../axios-pod';
import FilterItem from '../../components/FilterItem/FilterItem';
import Snooze from '../../components/Snooze/Snooze';
import SubheadingBar from '../../components/SubheadingBar/SubheadingBar';
import ConfirmationDialog from '../../components/UI/ConfirmationDialog/ConfirmationDialog';
import MainHeading from '../../components/UI/MainHeading/MainHeading';
import MainSection from '../../components/UI/MainSection/MainSection';
import MyDialog from '../../components/UI/MyDialog/MyDialog';
import MyTableLoader from '../../components/UI/MyTableLoader/MyTableLoader';
import SubHeading from '../../components/UI/SubHeading/SubHeading';
import SubSection from '../../components/UI/SubSection/SubSection';
import {
  IConfirmationDialogState,
  IFeed,
  IFilter,
  IFilterState,
  IPlaylist,
  IState,
  IUser
} from '../../models/states';
import {
  setMissingAssetsFilters,
  updateFilters
} from '../../store/actions/filterActions';
import {
  deselectPlaylist,
  escalatePlaylist,
  fetchPlaylists,
  fetchPlaylistsReject,
  resolvePlaylist,
  selectPlaylist,
  snoozePlaylist
} from '../../store/actions/playlistActions';
import {
  ConfirmationTypes,
  initialConfirmationState,
  prioritiesToEscalate,
  UserRoles
} from '../../utilities/utilities';
import withErrorHandler from '../../utilities/withErrorHandler';
import PlaylistPodTable from './PlaylistPodTable';
import PlaylistSummary from './PlaylistSummary';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    headerWrap: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    margin: {
      marginRight: '2rem',
      width: '25rem'
    },
    selectField: {
      background: 'rgba(255,255,255,0.2)',
      margin: '0 0.635rem',
      paddingLeft: '10px'
    },
    escalateWrapper: {
      display: 'flex',
      alignItems: 'flex-end',
      marginBottom: '1.5rem'
    }
  });

class PlaylistPod extends React.Component<IPlaylistPod, IPlaylistPodState> {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      selectedPlaylist: undefined,
      // selectedSupervisor: undefined,
      selectedPriority: undefined,
      confirmationDialogProps: initialConfirmationState,
      snoozeHrs: 0,
      snoozeMins: 0,
      openPlaylistSummary: false
    };
  }
  componentDidMount() {
    this.props.fetchPlaylists(true);
  }
  getFilteredData = () => {
    const { filters } = this.props;
    let playlists = [...Object.values(this.props.playlistMap)];
    // write separate filter for action

    Object.keys(filters.playlist).map(filterName => {
      const filterList = filters.playlist[filterName];
      const filterListWithSetLabel = filterList.filter(filter => filter.isSet);
      const filterListWithSetLabelList = filterListWithSetLabel.map(
        (filter: any) => {
          return filter.label;
        }
      );
      if (filterListWithSetLabel.length > 0) {
        playlists = playlists.filter((playlist: any) => {
          if (filterListWithSetLabelList.indexOf(playlist[filterName]) !== -1) {
            return true;
          } else {
            return false;
          }
        });
      }
    });
    return playlists;
  };
  componentWillUnmount() {
    this.props.fetchPlaylistsReject();
  }
  handleFilterToggle = (filterName: string, filter: IFilter) => {
    this.props.updateFilters('playlist', filterName, filter);
  };

  renderSubheading = (filteredDataLength: number) => {
    const originalPlaylistLength = Object.keys(this.props.playlistMap).length;
    return (
      <SubheadingBar
        title={'Playlists'}
        filteredItems={filteredDataLength}
        filters={this.props.filters.playlist}
        toggleFilter={this.handleFilterToggle}
        totalItems={originalPlaylistLength}
        showLoading={true}
        loading={this.props.isFetching}
        lastFetched={this.props.lastFetched}
      />
    );
  };
  handleSelectSupervisor = e => {
    this.setState({ selectedPriority: e.target.value });
  };
  renderResolveForm = () => {
    return (
      <div>
        <Typography>{`This will resolve the ticket and remove this item from the Pod. Do you wish to continue?`}</Typography>
      </div>
    );
  };
  renderSnoozeForm = () => {
    return (
      <Snooze
        mins={this.state.snoozeMins}
        hrs={this.state.snoozeHrs}
        para={undefined}
        onChangeSnoozeTime={this.handleSnoozeChange}
      />
    );
  };
  renderEscalateAllForm = () => {
    const { classes } = this.props;
    return (
      <div className={classes.escalateWrapper}>
        <Typography>{`Please select the priority to escalate : `}</Typography>
        <Select
          id="supervisorId"
          // value={
          //   this.state.selectedSupervisor ? this.state.selectedSupervisor : ''
          // }
          value={this.state.selectedPriority}
          className={classes.selectField}
          onChange={e => this.handleSelectSupervisor(e)}
          margin="none"
          name="supervisorId"
        >
          {prioritiesToEscalate.map((priority: string) => {
            return (
              <MenuItem
                key={prioritiesToEscalate.indexOf(priority)}
                value={prioritiesToEscalate.indexOf(priority) + 1}
              >
                {priority}
              </MenuItem>
            );
          })}
          {/* {this.props.users
            .filter(user =>
              user.role === UserRoles.SUPERVISOR &&
              user.screens.indexOf(this.props.selectedScreen) !== -1
                ? true
                : false
            )
            .map((user: IUser) => {
              return (
                <MenuItem key={user.userId} value={user.userId}>
                  {user.name}
                </MenuItem>
              );
            })} */}
        </Select>
      </div>
    );
  };
  renderConfirmationContent = () => {
    switch (this.state.confirmationDialogProps.type) {
      case ConfirmationTypes.SNOOZE:
        return this.renderSnoozeForm();
      case ConfirmationTypes.ESCALATE:
        return this.renderEscalateAllForm();
      case ConfirmationTypes.RESOLVE:
        return this.renderResolveForm();
      default:
        return null;
    }
  };

  handleOpenEscalateAllForm = () => {
    // const supervisors = this.props.users.filter(
    //   user => user.role === UserRoles.SUPERVISOR
    // );
    this.setState({
      // selectedSupervisor:
      //   supervisors.length > 0 ? supervisors[0].userId : undefined,
      selectedPriority: prioritiesToEscalate.length ? 1 : undefined,
      confirmationDialogProps: {
        type: ConfirmationTypes.ESCALATE,
        open: true,
        onCloseDialog: this.handleCloseEscalateAllForm,
        onProceedDialog: this.handleEscalateAll,
        content: this.renderEscalateAllForm(),
        title: 'escalate'
        // proceedDisabled: !this.state.selectedSupervisor
      }
    });
  };
  handleCloseEscalateAllForm = () => {
    this.setState({
      confirmationDialogProps: initialConfirmationState,
      // selectedSupervisor: undefined,
      selectedPriority: undefined
    });
  };
  handleEscalatePlaylist = (e, playlistId: string) => {
    e.stopPropagation();
    e.preventDefault();
    this.props.selectPlaylist(playlistId);
    this.handleOpenEscalateAllForm();
  };
  handleEscalateAll = () => {
    const payload = {
      playlist_id: this.props.selectedPlaylist,
      user_id: this.props.user.userId,
      priority: this.state.selectedPriority,
      // assignee: this.state.selectedSupervisor,
      screen: this.props.selectedScreen,
      epoch: 0
    };
    this.props.escalatePlaylist(payload);
    this.handleCloseEscalateAllForm();
    this.handleClosePlaylistSummary();
  };
  handleOpenSnoozeForm = () => {
    this.setState({
      confirmationDialogProps: {
        type: ConfirmationTypes.SNOOZE,
        open: true,
        onCloseDialog: this.handleCloseSnoozeForm,
        onProceedDialog: this.handleSnooze,
        content: this.renderSnoozeForm(),
        title: 'Snooze Assets'
      }
    });
  };
  handleCloseSnoozeForm = () => {
    this.setState({
      snoozeHrs: 0,
      confirmationDialogProps: initialConfirmationState
    });
  };
  handleSnooze = () => {
    const payload = {
      playlist_id: this.props.selectedPlaylist,
      user_id: this.props.user.userId,
      epoch: Math.floor(
        this.state.snoozeHrs * 3600 + Math.floor(this.state.snoozeMins) * 60
      ),
      // assignee: this.state.selectedSupervisor,
      screen: this.props.selectedScreen
    };
    this.props.snoozePlaylist(payload);
    this.handleCloseSnoozeForm();
    this.handleClosePlaylistSummary();
  };
  handleSnoozeChange = (e, type: string) => {
    if (type === 'hrs') {
      this.setState({ snoozeHrs: parseInt(e.target.value, 10) });
    } else {
      this.setState({ snoozeMins: parseInt(e.target.value, 10) });
    }
  };
  handleCloseResolveForm = () => {
    this.setState({
      confirmationDialogProps: initialConfirmationState
    });
  };
  handleOpenResolveForm = () => {
    this.setState({
      confirmationDialogProps: {
        type: ConfirmationTypes.RESOLVE,
        open: true,
        onCloseDialog: this.handleCloseResolveForm,
        onProceedDialog: this.handleResolve,
        content: this.renderResolveForm(),
        title: 'Resolve'
      }
    });
  };

  handleResolve = () => {
    const payload = {
      playlist_id: this.props.selectedPlaylist,
      user_id: this.props.user.userId,
      epoch: 0,
      // assignee: this.state.selectedSupervisor,
      screen: this.props.selectedScreen
    };
    this.props.resolvePlaylist(payload);
    this.handleCloseResolveForm();
    this.handleClosePlaylistSummary();
  };
  handleClosePlaylistSummary = () => {
    this.props.deselectPlaylist();
    this.setState({ openPlaylistSummary: false });
  };

  public render() {
    const { searchText } = this.state;
    const data = this.getFilteredData();
    const filteredData = data.filter(
      playlist =>
        !searchText ||
        playlist.customer.toLowerCase().indexOf(searchText.toLowerCase()) !==
          -1 ||
        playlist.feed_name.toLowerCase().indexOf(searchText.toLowerCase()) !==
          -1 ||
        (playlist.last_published &&
          playlist.last_published.id &&
          `${playlist.last_published.id}`
            .toLowerCase()
            .indexOf(searchText.toLowerCase()) !== -1)
    );

    return (
      <MainSection>
        <MainHeading
          mainHeading={'Playlist Monitor'}
          searchPlaceholder={'Search by customer, feed, playlist id...'}
          onSearch={event => this.setState({ searchText: event.target.value })}
          showButton={false}
        />
        <SubSection>
          <SubHeading>{this.renderSubheading(filteredData.length)}</SubHeading>
          {this.props.isFetching && this.props.fetchCount === 1 ? (
            <MyTableLoader />
          ) : (
            <PlaylistPodTable
              playlists={filteredData}
              feedMap={this.props.feedMap}
              onSelectPlaylist={this.props.selectPlaylist}
              onOpenPlaylistSummary={() =>
                this.setState({ openPlaylistSummary: true })
              }
              onDeselectPlaylist={this.props.deselectPlaylist}
              onToggleFilters={this.handleFilterToggle}
              filters={this.props.filters.playlist}
              onEscalate={this.handleEscalatePlaylist}
            />
          )}
        </SubSection>
        <ConfirmationDialog
          {...this.state.confirmationDialogProps}
          proceedDisabled={false}
        >
          {this.renderConfirmationContent()}
        </ConfirmationDialog>
        <MyDialog
          open={this.state.openPlaylistSummary}
          onClose={this.handleClosePlaylistSummary}
          title={'Playlist summary'}
          maxWidth={false}
        >
          {this.props.selectedPlaylist ? (
            <PlaylistSummary
              playlist={this.props.playlistMap[this.props.selectedPlaylist]}
              isOperator={
                this.props.user && this.props.user.role === UserRoles.OPERATOR
                  ? true
                  : false
              }
              onOpenEscalateForm={this.handleOpenEscalateAllForm}
              onOpenSnoozeForm={this.handleOpenSnoozeForm}
              onOpenResolveForm={this.handleOpenResolveForm}
              onUpdateFilters={this.props.updateFilters}
              filters={this.props.filters}
            />
          ) : null}
        </MyDialog>
      </MainSection>
    );
  }
}
interface IPlaylistPodOwnProps extends WithStyles<typeof styles> {}
interface IPlaylistPodStateProps {
  playlistIds: string[];
  playlistMap: { [key: string]: IPlaylist };
  isFetching: boolean;
  fetchCount: number;
  lastFetched: string;
  feedMap: { [key: string]: IFeed };
  selectedPlaylist: string;
  filters: IFilterState;
  user: IUser;
  users: IUser[];
  selectedScreen: string;
}
interface IPlaylistPodDispatchProps {
  fetchPlaylistsReject: () => any;
  fetchPlaylists: (resetFilters?: boolean) => any;
  selectPlaylist: (playlistId: string) => any;
  deselectPlaylist: () => any;
  updateFilters: (
    filterType: string,
    filterName: string,
    filter: IFilter
  ) => any;
  escalatePlaylist: (payload: any) => any;
  resolvePlaylist: (payload: any) => any;
  snoozePlaylist: (payload: any) => any;
}
interface IPlaylistPodState {
  searchText: string;
  snoozeHrs: number;
  snoozeMins: number;
  openPlaylistSummary: boolean;
  selectedPlaylist: string; // Playlist selected to show summary
  // selectedSupervisor: string; // supervisor id to raise jira ticket
  selectedPriority: number; // priority to raise freshdesk ticket
  confirmationDialogProps: IConfirmationDialogState;
}
type IPlaylistPod = IPlaylistPodOwnProps &
  IPlaylistPodDispatchProps &
  IPlaylistPodStateProps;

const mapStateToProps = (state: IState): IPlaylistPodStateProps => {
  return {
    playlistIds: state.playlists.playlistIds,
    playlistMap: state.playlists.playlistMap,
    isFetching: state.playlists.isFetching,
    fetchCount: state.playlists.fetchCount,
    lastFetched: state.playlists.lastFetched,
    feedMap: state.feeds.feedMap,
    selectedPlaylist: state.playlists.selectedPlaylist,
    filters: state.filters,
    user: state.user.userInfo,
    users: state.user.users,
    selectedScreen: state.screens.selectedScreen
  };
};
const mapDispatchToProps: IPlaylistPodDispatchProps = {
  updateFilters,
  fetchPlaylistsReject,
  fetchPlaylists,
  selectPlaylist,
  deselectPlaylist,
  escalatePlaylist,
  resolvePlaylist,
  snoozePlaylist
};
export default withStyles(styles)(
  connect<
    IPlaylistPodStateProps,
    IPlaylistPodDispatchProps,
    IPlaylistPodOwnProps
  >(
    mapStateToProps,
    mapDispatchToProps
  )(withErrorHandler(PlaylistPod, axios))
);
